import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';


export default
@observer class SelectSegmentType extends Component {

  setCustomerSegment(customer) {
    return function(event, index, value) {
      customer.segment = value;
    }
  }

  segmentChoices() {
    var list = [];
    AppModel.customer_segments.forEach(function(segmentType) {
      list.push(
        <MenuItem key={segmentType.id}
                  value={segmentType.id}
                  primaryText={
                    uiMsg('SEGMENT_TYPE_NAME_'+segmentType.id,segmentType.description)

                  }/>)
    });
    return list;
  }

  render() {
    var customer = this.props.customer;
    return (
      <SelectField
          floatingLabelText={uiMsg('SS_CUSTOMER_SEGMENT',"Customer segment")}
          hintText={uiMsg('SS_CUSTOMER_SEGMENT_HINT',"Customer segment")}
          value={customer.segment || AppModel.customer_segments[0].id}
          fullWidth={true}
          onChange={this.setCustomerSegment(customer)}>
          {this.segmentChoices()}
      </SelectField>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectSegmentType.jsx
 **/